import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function MasteryBar({ pathId, compact = false, refreshKey = 0 }) {
  const [m, setM] = useState(null);

  useEffect(() => {
    if (!pathId) return;
    api.get(`/mastery/${pathId}`).then(({ data }) => setM(data)).catch(() => {});
  }, [pathId, refreshKey]);

  if (!m) return null;
  const pct = m.equity || 0;
  const tier = pct >= 90 ? "Mastered" : pct >= 60 ? "Advancing" : pct >= 20 ? "Exploring" : "Starting";
  const color = pct >= 90 ? "#00FF9D" : pct >= 60 ? "#0044FF" : pct >= 20 ? "#FF7B00" : "#5D3FD3";

  return (
    <div className={compact ? "" : "glass p-5"} data-testid="mastery-bar">
      <div className="flex items-center justify-between mb-2">
        <div className="label-eyebrow">Knowledge Equity</div>
        <div className="text-xs text-white/50 font-mono-oak">
          <span style={{ color }}>{pct}%</span> · {tier}
        </div>
      </div>
      <div className="h-2 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full transition-all duration-700"
          style={{
            width: `${pct}%`,
            background: `linear-gradient(90deg, #5D3FD3, ${color})`,
            boxShadow: `0 0 14px ${color}55`,
          }}
        />
      </div>
      {!compact && m.breakdown && (
        <div className="grid grid-cols-3 gap-3 mt-4 text-[11px]">
          <Metric label="Modules" value={`${m.breakdown.modules_complete}/${m.steps}`} />
          <Metric label="Exams" value={`${m.breakdown.exams_taken}/${m.steps}`} sub={m.breakdown.exam_avg_score ? `${m.breakdown.exam_avg_score}% avg` : ""} />
          <Metric label="Saved" value={`${m.breakdown.library_saved}`} />
        </div>
      )}
    </div>
  );
}

function Metric({ label, value, sub }) {
  return (
    <div className="bg-white/[0.03] border border-white/10 rounded-lg px-3 py-2">
      <div className="text-white/45">{label}</div>
      <div className="font-display text-base text-white">{value}</div>
      {sub ? <div className="text-[10px] text-white/40">{sub}</div> : null}
    </div>
  );
}
